import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface ProjectPopoverMenuListProps {
  projectId: number
  projectName: string
  canManageProjects: boolean
  canCreateProjects: boolean
  canDeleteProjects: boolean
  canAssignEmployees: boolean
  hasSubprojectsFeature: boolean
}

const ProjectPopoverMenuList = ({
  projectId,
  projectName,
  canManageProjects,
  canCreateProjects,
  canDeleteProjects,
  canAssignEmployees,
  hasSubprojectsFeature,
}: ProjectPopoverMenuListProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const showMenu = canAssignEmployees || canManageProjects || canDeleteProjects
  const showDuplicateProject = canCreateProjects && hasSubprojectsFeature

  if (!showMenu) return null

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative
          type="secondary"
          aria-label="Project popover menu button"
          iconName="ellipsis"
        />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        {canAssignEmployees && (
          <PopoverMenu.TouchableOption
            title={i18n.t('project_management.table.projects_list.menu_links.assign_employees')}
            onClick={() => {
              track(trackingEvents.projectManagement.projectWorker.assignEmployeesToProjectStart)
              navigate(navigation.projects.id.details.employees.workers.fullPath({ id: projectId }))
            }}
          />
        )}
        {showDuplicateProject && (
          <PopoverMenu.TouchableOption
            title={i18n.t('project_management.table.projects_list.menu_links.duplicate_project')}
            onClick={() => {
              track(
                trackingEvents.projectManagement.projects.duplicateProject.duplicateProjectStart
              )
              navigate(
                navigation.projects.list.projectId.duplicate.fullPath({ projectId: projectId }),
                {
                  state: { projectName, hasSubprojectsFeature },
                }
              )
            }}
          />
        )}
        {canManageProjects && (
          <PopoverMenu.TouchableOption
            title={i18n.t('project_management.table.projects_list.menu_links.settings')}
            onClick={() => {
              track(trackingEvents.projectManagement.settings.visitProjectSettings, {
                origin: 'Project list page',
              })
              navigate(navigation.projects.id.settings.fullPath({ id: projectId }))
            }}
          />
        )}
        {canDeleteProjects && (
          <PopoverMenu.TouchableOption
            danger
            title={i18n.t('project_management.table.projects_list.menu_links.delete_project')}
            onClick={() => {
              track(trackingEvents.projectManagement.projects.deleteProjectStart)
              navigate(
                navigation.projects.list.projectId.delete.fullPath({ projectId: projectId }),
                {
                  state: { projectName },
                }
              )
            }}
          />
        )}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default ProjectPopoverMenuList
